import React, { FunctionComponent, useContext } from "react";
import { EditRouteStopsContext } from "./edit-route-stops.context";
import { Backdrop, CircularProgress, Grid, Theme, makeStyles } from "@material-ui/core";
import { RouteContext } from "./route-context";
import { ContentContainer } from "../../../components/content-container/content-container";
import { RouteDetailsMap } from "./route-details-map";
import { RouteDetailsTable } from "./route-details-table";

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
  },
}));

export const RouteDetailsContent: FunctionComponent = () => {
  const { isUpdating } = useContext(EditRouteStopsContext);
  const { routeLoading, route } = useContext(RouteContext);

  const classes = useStyles();

  return (
    <>
      <Backdrop open={isUpdating || routeLoading} className={classes.backdrop}>
        <CircularProgress color="primary" />
      </Backdrop>
      {!routeLoading && route && (
        <Grid item xs={12}>
          <Grid item>
            <ContentContainer>
              <RouteDetailsMap />
            </ContentContainer>
          </Grid>
          <Grid item>
            <ContentContainer>
              <RouteDetailsTable />
            </ContentContainer>
          </Grid>
        </Grid>
      )}
    </>
  );
};
